import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import LeaveConfirmationModal from './components/Common/LeaveConfirmationModal';

const leaveMessage = 'You may lose all unsaved changes, do you still want to continue?';

const AppRouter = ({ children }) => {
    const [isShowConfirmationModal, setIsShowConfirmationModal] = React.useState(false);
    const [leaveConfirmationContent, setLeaveConfirmationContent] = React.useState({});
    const isDirty = useSelector(state => state.appData.isDirty);

    const doConfirm = (message, callback) => {
        setIsShowConfirmationModal(true);
        setLeaveConfirmationContent({ message, onLeave: callback });
    }

    React.useEffect(() => {
        const handleUnload = (e) => {
            if (isDirty) {
                setIsShowConfirmationModal(false);
                e.returnValue = leaveMessage;
                return leaveMessage;
            }
        }
        window.addEventListener("beforeunload", handleUnload);

        return () => {
            window.removeEventListener("beforeunload", handleUnload);
        }

    }, [isDirty]);

    const handleClose = () => {
        setIsShowConfirmationModal(false);
    }

    return (
        <BrowserRouter
            getUserConfirmation={doConfirm}
            basename="/"
        >
            {children}
            {isShowConfirmationModal && (
                <LeaveConfirmationModal
                    {...leaveConfirmationContent}
                    isOpen={isShowConfirmationModal}
                    onClose={handleClose}
                />
            )}
        </BrowserRouter>
    )
}

export default AppRouter;